import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog } from '../../types'
import { CmsConverterService, defaultFSCatalog } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class PanelRowRelatedProductsConverter extends CmsConverterService<PanelRowRelatedProductsData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      links: formData.st_panel_row_related_products_links_list ?? defaultFSCatalog
    }
  }
}

export const PANEL_ROW_RELATED_PRODUCTS_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, PanelRowRelatedProductsData>>('PanelRowRelatedProductsConverter')

export interface PanelRowRelatedProductsData extends ConvertedComponentData {
  links: FsCatalog;
}
